export const objectivePartsTableColumns = [
  { label: 'Nome da Parte', value: 'display_name' },
  { label: 'Sistema', value: 'systems_display_name' },
  { label: 'Ações', value: 'actions', className: 'w-11' },
];
